export default __webpack_public_path__ + "static/media/leftArrow.0751bb3c.svg";